module.exports = __webpack_public_path__ + "static/media/online-teaching-img5.45497c14.jpg";